import React from "react";
import {withRouter} from 'react-router-dom';
import {Grid} from "@material-ui/core";
import cvSrc from "../../assets/docs/SaiTejaMalladi.pdf";
import profileData from "../../assets/static/profile.json";
import classes from "./ProfessionalSummary.module.css";

const ProfessionalSummary = (props) => {
	let profile = profileData.profile;
	return (
		<Grid container spacing={4} alignItems={"center"} justify={"center"} className={classes.Container}>
			<Grid item sm={12} md={5}>
				<img src={profile.pic} alt={profile.name} className={classes.ProfilePic} />
			</Grid>
			<Grid item sm={12} md={7}>
				<div className={classes.ProfileSummary}>
					<h4>{profile.role}</h4>
					<h2>{profile.name}</h2>
					<p>{profile.summary}</p>
				</div>
				<Grid container spacing={2} justify={"space-around"} className={classes.Container}>
					<Grid item sm={12} md={7}>
						<button
							className={classes.DownloadButton}
						>
							<a href={cvSrc} download>Download CV</a>
						</button>
					</Grid>
					<Grid item sm={12} md={5}>
						<button
							className={classes.ContactButton}
							onClick={() => props.history.push('contact')}>
							Contact
						</button>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}
export default withRouter(ProfessionalSummary);